import React, {useEffect, useState} from 'react';
import {Button, Bubble, Modal, Dropdown, StatusTip, List} from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { IGetTableInfoDto, ITableColumnClassDto, ITableColumnDto } from '@dbl/services/dataSource';
import { UpdateColumnInfo } from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import {ReactSortable} from 'react-sortablejs';
import type { IColumnInfo, IColumnRawInfo } from '@dbl/core/dataSource';
import {dragOnMove, initDragStatus} from '@/pages/datalab/components/SortableDrag/utils';
import {TDispatchFun, SortableItems} from '@/pages/datalab/components/SortableDrag/configration';
import {
  duplicateNameVerification,
  EditList,
  RenameWrapper
} from "@/pages/datalab/components/SortableDrag/FieldEditComponents";
import { useSafeState } from 'ahooks';
import {getLocalText} from "@/pages/datalab/utils/utils";
import DetailModal from "@/pages/datalab/pages/Multidimensional/Analysis/components/DetailModal";
import { FieldType } from '@dbl/core/dataSource';

const FieldClassIconNameMap = {
  // 公共: 'bag-alt',
  维度: 'gear-m',
  指标: 'port-path-icon',
};
const FieldTypeIcon = {
  'date': 'date',
  'time': 'time',
  'string': 'abc',
  'number': 'a-123',
  'float': 'a-123',
  'percent': 'a-123',
};

let currentDragItem: IColumnInfo | null = null;
export default function MenuTab(props: any) {
  const {
    namespace,
    searchValue,
    tableInfo,
    deleteTab,
    openDetailModal,
    detailProps,
    clickField,
    multiFormatMessage,
    commonFormatMessage,
    isEn,
    dragState,
  }: {
    namespace: string;
    searchValue: string;
    tableInfo: IGetTableInfoDto;
    deleteTab?: () => void;
    clickField?: (e: any, columnRawInfo: IColumnRawInfo) => void;
    multiFormatMessage: Function;
    commonFormatMessage: Function;
    isEn: boolean;
    dragState: {errorDrag: string;};
  } = props;
  const [isShow, setIsShow] = useState(true);
  const [delectData, setDelectData] = useState(false);
  // const [columnBubbleVisible, setColumnBubbleVisible] = useState(true);
  const [renameSelectComp, setRenameSelectComp] = useSafeState<string>('');
  
  useEffect(() => {
    if (searchValue) {
      setIsShow(true);
    }
  }, [searchValue]);
	
  const dragOnMoveHandle = (evt: any, originalEvent: any) => {
    const {to} = evt;
    const sortableClass = to.className.split(' ').find((item: string) => item.includes(`-${SortableItems}`));
    const sortableKey = sortableClass.slice(0, sortableClass.indexOf(`-${SortableItems}`));
    const {[sortableKey]: columnInfos} = props;
    return dragOnMove(evt, originalEvent, sortableKey, columnInfos, dispatchFun, currentDragItem);
  };
	
  const dispatchFun: TDispatchFun = (path: string, payload: {}, callback?: Function) => {
    props.dispatch({
      type: `${namespace}/${path}`,
      payload,
      callback,
    });
  };
	
  const updateField = (payload: UpdateColumnInfo, callback: Function) => {
    dispatchFun(
      'updateTableField',
      {
        table_id: tableInfo.table_id,
        isEn,
        ...payload,
      },
      callback
    );
  };
  
  const tableName = getLocalText(isEn, tableInfo?.customize_name, tableInfo?.customize_name_en, tableInfo?.table_name);
  
  return (
    <div className="field_list">
      <div className="field_list-bh">
        <div
          className="bh-show"
          onClick={() => {
            setIsShow(!isShow);
          }}
        >
          <SvgIcon type="point-down" className={isShow ? 'bh-action' : 'bh-change'}/>
          <span
            className="bh-text">{`${tableInfo.only_one_table ? '' : tableInfo.table_code} ${tableName}`}</span>
        </div>
        
        {
          deleteTab ? (<Dropdown
            className={'column-item-more bh-icon'}
            boxClassName={'column-item-drop'}
            updateOnChildrenChange={true}
            placement={"bottom-end"}
            clickClose={false}
            button={<SvgIcon type={'more'}/>}
            appearance={'pure'}
          >
            {
              close => (<List type={'option'}>
                <List.Item onClick={() => {
                  openDetailModal();
                  close();
                }}> {commonFormatMessage('detail')} </List.Item>
                <List.Item onClick={() => {
                  setDelectData(true);
                  close();
                }}> {commonFormatMessage('delete')} </List.Item>
              </List>)
            }
          </Dropdown>) : ''
        }
      </div>
      {(tableInfo.column_class_list || []).map((columnClass: ITableColumnClassDto, index) => columnClass?.columns?.length > 0 ? (
        <div className={isShow ? 'field_list-bd height-nomal' : 'field_list-bd height-0'} key={index} onMouseDown={(event) => event.preventDefault()}>
          {columnClass.name ? (
            <div className="bd-group">
              <SvgIcon type={FieldClassIconNameMap[columnClass.name]} className="bd-icon"/>
              {isEn ? columnClass.name_en : columnClass.name}
            </div>
          ) : null}
          {clickField ? (
            <TableItems  setRenameSelectComp={setRenameSelectComp} columnClass={columnClass} clickField={clickField} isEn={isEn} updateField={updateField} columnList={tableInfo.column_list || []}/>
          ) : (
            <ReactSortable
              group={{
                name: 'groupName',
                pull: 'clone',
                put: false,
              }}
              chosen={false}
              filter={'.colunm-item-loading'}
              dragClass="colunm-drag"
              sort={false}
              handle={'.colunm-item-wrap'}
              animation={0}
              // delay={50}
              disabled={!!renameSelectComp}
              forceFallback={true}
              list={columnClass.columns}
              setList={() => {
              }}
              onStart={(evt) => {
                const list = columnClass.columns;
                currentDragItem = list[evt.oldIndex || 0];
                // setColumnBubbleVisible(false);
              }}
              onMove={dragOnMoveHandle}
              onEnd={() => {
                initDragStatus(dispatchFun);
              }}
            >
              <TableItems   setRenameSelectComp={setRenameSelectComp} columnClass={columnClass} clickField={clickField} isEn={isEn} updateField={updateField} columnList={tableInfo.column_list || []}/>
            </ReactSortable>
          )}
        </div>
      ) : '')}
      <DelectData
        tableInfo={tableInfo}
        delectData={delectData}
        close={() => {
          setDelectData(false);
        }}
        confirm={() => {
          deleteTab?.();
        }}
        multiFormatMessage={multiFormatMessage}
        commonFormatMessage={commonFormatMessage}
      />
      {
        detailProps ? (<DetailModal
          {...detailProps}
          className={'dbl-add-source-detail-modal'}
        />) : ''
      }
      
    </div>
  );
}

const TableItems = (props: {
  columnClass: ITableColumnClassDto;
  columnList: ITableColumnDto[];
  clickField?: (e: any, columnRawInfo: IColumnRawInfo) => void;
  isEn: boolean;
  updateField: Function;
  setRenameSelectComp: (...args: any[]) => void;
}) => {
  const {columnClass, clickField, isEn, updateField, columnList, setRenameSelectComp} = props;
  const [loadingIds, setLoadingIds] = useState<any>(new Set());
  const [editingId, setEditingId] = useState<string>('');
  const updateHandle = (column: IColumnRawInfo, updateColumn: any) => {
    // loadingIds.add(column.id);
    setLoadingIds(loadingIds);
    updateField(
      {
        column,
        updateColumn
      }
      // (isSuccess: boolean) => {
      // 	loadingIds.delete(column.id);
      // 	setLoadingIds(loadingIds);
      // 	// 弹出编辑成功
      // 	// if (isSuccess) {
      // 	// 	notification.success({
      // 	// 		description: isEn ? 'Save Success' : '保存成功',
      // 	// 	});
      // 	// } else {
      // 	// 	notification.error({
      // 	// 		description: isEn ? 'Save Fail' : '保存失败',
      // 	// 	});
      // 	// }
      // }
    );
  };
  const handleSetSelectionRange=(fn: Function, value: string)=>{
    fn?.();
    if(value){
      setRenameSelectComp(value);
    }
  };
  return (
    <>
      {' '}
      {(columnClass.columns || []).map((columnRawInfo: IColumnInfo, index) => (
        <div
          className={`bd-flex colunm-item-wrap ${editingId === columnRawInfo.id ? 'editing' : ''} ${loadingIds.has(columnRawInfo.id) ? 'column-item-loading' : ''}`}
          key={index}
          onClick={(event: any) => {
            clickField?.(event, columnRawInfo);
          }}
        >
          <RenameWrapper
            setRenameSelectComp={setRenameSelectComp}
            className={'column-item-input'}
            isEn={isEn}
            oldName={columnRawInfo.column_display }
            changeRename={(name: string) => {
              if (duplicateNameVerification(columnList, name, isEn)) {
                return isEn ? 'Duplicate naming' : '重复命名';
              }
              updateHandle(columnRawInfo, {display_name: name});
            }}
            renderItem={(ref: any, clickRename: Function) => {
              const isMetric = columnRawInfo.is_metric;
              const options: any[] = [
                {type: 'rename', onClick: ()=>handleSetSelectionRange(clickRename,isEn ? columnRawInfo.column_display_en : columnRawInfo.column_display)},
                {type: 'transform', value: isMetric, onChange: updateHandle},
                {type: 'fieldType', value: columnRawInfo.column_type, decimal: columnRawInfo.accuracy, date_format: columnRawInfo.date_format, onChange: updateHandle},
                {type: 'displayFormat', disabled: ![FieldType.Number, FieldType.Percent, FieldType.Float].includes(columnRawInfo?.column_type), hideUnit: columnRawInfo?.column_type === FieldType.Percent, accuracy: columnRawInfo.accuracy, unit: columnRawInfo.unit, onChange: updateHandle}
              ];
              (!isMetric) && options.push(
                {type: 'dimensionValue', value: columnRawInfo.dimension_setting, onChange: updateHandle});
								
              // && (columnRawInfo.column_type !== 'date') && options.push({type: 'include255', value: columnRawInfo.flag, onChange: updateHandle});
								
              return (<>
                <SvgIcon type={FieldTypeIcon[columnRawInfo.column_type] || "abc"} className={'column-item-type'}/>
                <Bubble
                  placement="top"
                  key={index}
                  dark
                  closeOnScroll
                  content={TableColunmBubbleContent([
                    columnRawInfo.column_name,
                    columnRawInfo.column_display,
                    isEn ? columnRawInfo.column_remark_en : columnRawInfo.column_remark,
                  ])}
                >
                  {/* 需求变更: 字段名称使用原有字段中文名称或字段原始名称展示, 没有中英文切换 */}
                  <div
                    className="bd-flex-text">{columnRawInfo.column_display || columnRawInfo.column_name}</div>
                  <div className="bd-flex-desc">{columnRawInfo.column_name}</div>
                </Bubble>
                {
                  !clickField ? (<Dropdown
                    className={'column-item-more'}
                    boxClassName={'column-item-drop'}
                    updateOnChildrenChange={true}
                    placementOffset={[-14, 8]}
                    placement={"right-start"}
                    clickClose={false}
                    button={<SvgIcon type={'more'}/>}
                    appearance={'pure'}
                    onOpenChange={(open) => {
                      setEditingId(open ? columnRawInfo.id : '');
                    }}
                  >
                    {
                      (close) => (<EditList
                        key={index}
                        className={'column-item-drop-edit'}
                        options={options}
                        close={close}
                        column={columnRawInfo}
                      />)
                    }
										
                  </Dropdown>) : ''
                }

              </>);
            }}
          />
          <StatusTip className={'column-item-loading-icon'} status={'loading'} loadingText={''}/>
        </div>
      )
      )}
    </>
  );
};

const DelectData = (props: any) => {
  const {tableInfo, delectData, confirm, close, multiFormatMessage, commonFormatMessage} = props;
  return (
    <Modal
      visible={delectData}
      onClose={() => {
        close();
      }}
    >
      <Modal.Body>
        <div className="model-delect">
          <div className="model-delect-title">{multiFormatMessage("delete_table")}</div>
          <div className="model-delect-text">
            {multiFormatMessage("delete_table")} <span
              className="action">{`${tableInfo.table_code} ${tableInfo.table_name}`}</span>{' '}
            {multiFormatMessage("re_analysis")}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            close?.();
            confirm?.();
          }}
        >
          {commonFormatMessage("confirm")}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            close?.();
          }}
        >
          {commonFormatMessage("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

function TableColunmBubbleContent(contents: (string | undefined)[]) {
  return (
    <div style={{maxWidth: 400}}>
      {contents.map((content, index) => (
        content ? <p key={index}>{content}</p> : ''
      ))}
    </div>
  );
}